import PropTypes from 'prop-types';

import { Chip } from '@mui/material';
import { getApprovalStatus } from '../DocumentsView/helpers/documentsHelpers';

import { useBreakpoints } from '../../../../hooks/useBreakpoints';

/**
 * Component to display the approval status of a document or demand using a chip indicator.
 *
 * @param {Object} props - Component props.
 * @param {Object} props.data - Data object containing details about the demand.
 * @returns {JSX.Element|null} A Material-UI chip if there is an approval status; otherwise, null.
 */
const DemandStatus = ({ data }) => {
  const approvalStatus = getApprovalStatus(data);
  const { isTablet } = useBreakpoints();
  const size = isTablet ? 'small' : 'medium';

  if (!approvalStatus) {
    return;
  }

  return <Chip size={size} label="En attente d'approbation" />;
};

DemandStatus.propTypes = {
  data: PropTypes.object
};

export default DemandStatus;
